module.exports = "<div class=\"info-container\">\n  <h2>cDots Content Management System build for Arton OOD</h2>\n  <span>v. 1.0.0000.2017</span>\n  <p>Copyright © 2017 cDots LTD.</p>\n  <a href=\"http://cdots-corporation.com/\" target=\"_blank\">cdots-corporation.com</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/+app/+admin-app/+about/about.component.html
// module id = 572
// module chunks = 0